const pad = value => String(value).padStart(2, '0');

export function localParts(date = new Date()) {
  return {
    date: `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`,
    time: `${pad(date.getHours())}:${pad(date.getMinutes())}`,
    dayBit: date.getDay() === 0 ? 64 : 1 << (date.getDay() - 1),
    weekType: isoWeek(date) % 2 > 0 ? 1 : 2
  };
}

export function isoWeek(date) {
  const day = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  day.setDate(day.getDate() - ((day.getDay() + 6) % 7) + 3);
  const firstThursday = new Date(day.getFullYear(), 0, 4);
  firstThursday.setDate(firstThursday.getDate() - ((firstThursday.getDay() + 6) % 7) + 3);
  return 1 + Math.round((day - firstThursday) / (7 * 24 * 3600 * 1000));
}

export function parseRules(inactivity) {
  if (!inactivity) return [];
  try {
    const rules = typeof inactivity === 'string' ? JSON.parse(inactivity) : inactivity;
    return Array.isArray(rules) ? rules : [];
  } catch (e) {
    return [];
  }
}

export function ruleMatches(rule, now = new Date()) {
  const { date, time, dayBit, weekType } = localParts(now);
  if (rule.type && rule.type !== weekType) return false;
  if (rule.workdays) {
    if ((rule.workdays & dayBit) === 0) return false;
  } else if (!rule.fromDate || !rule.toDate) {
    return false;
  }
  if (rule.fromDate && rule.toDate && (date < rule.fromDate || date > rule.toDate)) return false;
  return rule.start === rule.end || (time >= rule.start && time < rule.end);
}

export function isInactiveNow(employee, now = new Date()) {
  return parseRules(employee.inactivity).some(rule => ruleMatches(rule, now));
}
